import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useI18n } from "../i18n";
import { useAuth } from "../auth";

const formatDate = (iso, lang) => {
  try {
    return new Date(iso).toLocaleString(
      lang === "es" ? "es-ES" : lang === "pt" ? "pt-BR" : "en-US"
    );
  } catch {
    return iso;
  }
};

export default function Logs() {
  const { t, lang } = useI18n();
  const { user } = useAuth();
  const [logs, setLogs] = useState([]);
  const [scope, setScope] = useState("me"); // me | all (admin)

  const load = () => {
    const url = scope === "all" ? "/logs" : "/logs/me";
    api.get(url).then((r) => setLogs(r.data));
  };

  useEffect(() => {
    load();
  }, [scope]);

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="logs-page">
      <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
        <div>
          <div className="text-[11px] uppercase tracking-[0.25em] font-bold text-white/50">
            {t("nav_logs")}
          </div>
          <h1 className="font-display text-4xl sm:text-5xl font-[900] uppercase mt-2">
            {scope === "all" ? t("all_logs") : t("my_logs")}
          </h1>
        </div>
        {user?.role === "admin" && (
          <div className="flex gap-2">
            <button
              onClick={() => setScope("me")}
              data-testid="logs-scope-me"
              className={`h-9 px-4 text-[11px] uppercase tracking-[0.2em] font-bold border transition-colors ${
                scope === "me" ? "bg-white text-black border-white" : "text-white/60 border-white/15"
              }`}
            >
              {t("my_logs")}
            </button>
            <button
              onClick={() => setScope("all")}
              data-testid="logs-scope-all"
              className={`h-9 px-4 text-[11px] uppercase tracking-[0.2em] font-bold border transition-colors ${
                scope === "all" ? "bg-white text-black border-white" : "text-white/60 border-white/15"
              }`}
            >
              {t("all_logs")}
            </button>
          </div>
        )}
      </div>

      {logs.length === 0 ? (
        <div className="text-white/50 text-sm">{t("no_logs")}</div>
      ) : (
        <div className="border border-white/10 bg-[#141414]" data-testid="logs-table">
          <div className="grid grid-cols-[160px_140px_120px_1fr] border-b border-white/10 px-4 py-3 text-[10px] uppercase tracking-[0.25em] font-bold text-white/50">
            <span>{t("time")}</span>
            <span>{t("player")}</span>
            <span>{t("action")}</span>
            <span>{t("details")}</span>
          </div>
          {logs.map((l) => (
            <div
              key={l.id}
              className="grid grid-cols-[160px_140px_120px_1fr] items-center px-4 py-3 border-b border-white/5 text-sm hover:bg-white/[0.03]"
              data-testid={`log-row-${l.id}`}
            >
              <span className="text-xs text-white/50 font-mono">{formatDate(l.timestamp, lang)}</span>
              <span className="text-xs font-bold">@{l.username}</span>
              <span className="text-[10px] uppercase tracking-[0.2em] font-bold text-[#007AFF]">
                {l.action}
              </span>
              <span className="text-xs text-white/70">{l.details}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
